import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getPO(params) {
	return client.get("api/po/data", {
		params: params,
	});
}

function getPOAll(params) {
	return client.get("api/po/all", {
		params: params,
	});
}

function getOptionStatus() {
	return client.get("api/options/po-status");
}

function exportPO(params) {
	return client.get("api/po/export", {
		params: params,
	});
}

function exportPOAll(params) {
	return client.get("api/po/export-all", {
		params: params,
	});
}



function downloadExportPO(url) {
	return client.get(url);
}

function detailPO(params) {
	return client.get("api/po/detail", {
		params: {
			po_code : params
		},
	});
}

function getSupplierProducts (params) {
	return client.get("api/options/product-by-supplier", {
		params: params,
	});
}

function createPO (params) {
	return client.post("api/po/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function approvePO (params) {
	return client.post("api/po/approve", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function rejectPO (params) {
	return client.post("api/po/reject", qs.stringify({
		po_id: params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deletePO (params) {
	return client.post("api/po/delete", qs.stringify({
		po_id: params
	}), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getPO,
	getPOAll,
	getOptionStatus,
	exportPO,
	exportPOAll,
	downloadExportPO,
	detailPO,
	getSupplierProducts,
	createPO,
	approvePO,
	rejectPO,
	deletePO
};